import { inject, Injectable } from '@angular/core';
import { round } from 'es-toolkit/compat';
import { Observable } from 'rxjs';

import { CsvAsStringArrays } from '@malou-io/package-utils';

import { RestaurantStore } from '#modules/restaurants/stores/restaurant.store';
import { WheelOfFortuneGiftsStatisticsData } from '#modules/statistics-boosters/models/aggregated-booster.interface';
import { BoostersDataFetchingServiceV2 } from '#modules/statistics-boosters/services/get-boosters-data-v2.service';
import { AbstractCsvService } from '#modules/statistics/components/download-insights-modal/models/csv-service.abstract';
import { StatisticsStore } from '#modules/statistics/stores/store/statistics.store';
import { GIFT_PERCENTAGE_DECIMALS } from '#shared/constants/index';

type Data = WheelOfFortuneGiftsStatisticsData;

@Injectable()
export class BoostersGiftsCsvInsightService extends AbstractCsvService<Data> {
    private readonly _statisticsStore = inject(StatisticsStore);
    private readonly _boostersDataFetchingService = inject(BoostersDataFetchingServiceV2);
    private readonly _restaurantStore = inject(RestaurantStore);

    protected _getData$(): Observable<Data> {
        const params = {
            dates: this._statisticsStore.filters().dates,
            comparisonPeriod: this._statisticsStore.filters().comparisonPeriod,
            restaurantIdForSummaryCsv: this._restaurantStore.currentRestaurantId(),
        };
        return this._boostersDataFetchingService.getGiftsData(params);
    }

    protected override _isDataValid(data: Data): boolean {
        return data.giftsInsightsPerGift.length > 0;
    }

    protected override _getCsvHeaderRow(): string[] {
        return ['Gift', 'Winners Count', 'Retrieved Gift Count', 'Retrieved Gift Ratio'];
    }

    protected override _getCsvDataRows({ giftsInsightsPerGift }: Data): CsvAsStringArrays {
        return giftsInsightsPerGift.map(({ gift, giftDrawCount, retrievedGiftDrawCount }) => [
            gift,
            giftDrawCount ? giftDrawCount.toString() : '0',
            retrievedGiftDrawCount ? retrievedGiftDrawCount.toString() : '0',
            retrievedGiftDrawCount ? `${round((retrievedGiftDrawCount / giftDrawCount) * 100, GIFT_PERCENTAGE_DECIMALS)}%` : '0%',
        ]);
    }
}
